import { useState, useEffect } from 'react';
import SubscriptionDetail from './SubscriptionDetail';
import { getAllAnchors } from "../services/anchorService";
import { fetchWATemplates } from "../services/watemplateService";
import { fetchSubscriptionTemplates } from '../services/subTemplateService';
import { fetchSubscriptions } from "../services/subscriptionService";
import CreateSubTemplate from './CreateSubTemplate';
import { MultiSelectDropdown } from '../components/MultiSelectDropdown'

const Subscription = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [anchors, setAnchors] = useState([]);
  const [waTemplates, setWATemplates] = useState([]);
  const [planList, setPlanList] = useState([]);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [creating, setCreating] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedAnchors, setSelectedAnchors] = useState([]);
  const [selectedPlans, setSelectedPlans] = useState([]);
  const [selectedTemplates, setSelectedTemplates] = useState([]);




  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSubscriptions = subscriptions.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(subscriptions.length / itemsPerPage);



  useEffect(() => {
    const fetchSubscriptionTemplatesList = async () => {
      try {
        const data = await fetchSubscriptionTemplates();
        setSubscriptions(data);
        setCurrentPage(1)
      } catch (error) {
        console.error('Failed to fetch subscriptions:', error);
      } finally {
        setLoading(false);
      }
    };
    const fetchInitialData = async () => {
      try {
        const [anchorList, templateList, subscriptionList] = await Promise.all([
          getAllAnchors(),
          fetchWATemplates(),
          fetchSubscriptions(),
        ]);
        setAnchors(anchorList);
        setWATemplates(templateList);
        setPlanList(subscriptionList);
      } catch (error) {
        console.error("Failed to load anchors, templates, or subscriptions:", error);
      }
    };



    fetchSubscriptionTemplatesList();
    fetchInitialData();
  }, []);

  const handleApplyFilters = async () => {
    const filters = {};

    if (selectedAnchors.length > 0) filters.anchor_id = selectedAnchors.join(',');
    if (selectedPlans.length > 0) filters.subscription_id = selectedPlans.join(',');
    if (selectedTemplates.length > 0) filters.watemplate_id = selectedTemplates.join(',');

    try {
      const data = await fetchSubscriptionTemplates(filters);
      setSubscriptions(data);
      setCurrentPage(1);
    } catch (error) {
      console.error("Failed to apply filters:", error);
    }
  };

  const handleClearFilters = async () => {
    setSelectedAnchors([]);
    setSelectedPlans([]);
    setSelectedTemplates([]);

    try {
      const data = await fetchSubscriptionTemplates();
      setSubscriptions(data);
      setCurrentPage(1);
    } catch (error) {
      console.error("Failed to clear filters:", error);
    }
  };



  const handleRowClick = (subscription) => {
    setSelectedSubscription(subscription);
  };

  const handleBack = () => {
    setSelectedSubscription(null);
    setCreating(false);
  };

  const formatTimeLabel = (timeStr) => {
    const [hours, minutes] = timeStr.split(":");
    const date = new Date();
    date.setHours(Number(hours), Number(minutes), 0);
    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  if (loading) return <div className="p-4">Loading...</div>;

  return (
    <div className="p-4">
      {!selectedSubscription && !creating ? (
        <>
          <h2 className="text-xl font-semibold mb-4">Subscription Templates</h2>
          <div className="flex items-end">
            <button
              onClick={() => setCreating(true)}
              className="bg-green-600 text-white px-4 py-2 my-2 rounded hover:bg-green-700"
            >
              + Create Subscription Template
            </button>
          </div>

          {/*filters*/}
          <div className="flex flex-wrap gap-4 my-4">
            <MultiSelectDropdown
              label="Anchors"
              options={anchors}
              selected={selectedAnchors}
              setSelected={setSelectedAnchors}
            />

            <MultiSelectDropdown
              label="Plans"
              options={planList}
              selected={selectedPlans}
              setSelected={setSelectedPlans}
            />

            <MultiSelectDropdown
              label="WA Templates"
              options={waTemplates}
              selected={selectedTemplates}
              setSelected={setSelectedTemplates}
            />

            <button
              className="bg-blue-600 text-white px-4 py-2 rounded h-fit"
              onClick={handleApplyFilters}
            >
              Apply Filters
            </button>

            <button
              className="bg-gray-400 text-white px-4 py-2 rounded h-fit"
              onClick={handleClearFilters}
            >
              Clear
            </button>
          </div>



          <table className="min-w-full table-auto border">
            <thead>
              <tr className="bg-gray-100 text-left">

                <th className="px-4 py-2 border">Anchor</th>
                <th className="px-4 py-2 border">Plan</th>
                <th className="px-4 py-2 border">wa template</th>
                <th className="px-4 py-2 border">Day</th>
                <th className="px-4 py-2 border">Time</th>
                <th className="px-4 py-2 border">Active</th>
              </tr>
            </thead>
            <tbody>
              {currentSubscriptions.map((sub) => (
                <tr
                  key={sub.id}
                  className="hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleRowClick(sub)}
                >

                  <td className="px-4 py-2 border">
                    {anchors.find((anchor) => anchor.id === sub.anchor)?.name || 'N/A'}
                  </td>
                  <td className="px-4 py-2 border">
                    {planList.find((plan) => plan.id === sub.subscription)?.name || 'N/A'}
                  </td>
                  <td className="px-4 py-2 border">
                    {waTemplates.find((template) => template.id === sub.watemplate)?.name || 'N/A'}
                  </td>

                  <td className="px-4 py-2 border">{sub.day}</td>
                  <td className="px-4 py-2 border">{formatTimeLabel(sub.time)}</td>
                  <td className={`px-4 py-2 border font-semibold flex items-center space-x-2 ${sub.active ? "text-green-600" : "text-red-600"
                    }`}>
                    <span>
                      {sub.active ? "✅ Active" : "❌ Inactive"}
                    </span>
                  </td>


                </tr>
              ))}
            </tbody>
          </table>
          {/*Pgination*/}
          {totalPages > 1 && (
            <div className="mt-4 flex gap-2 items-center">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Prev
              </button>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i + 1}
                  onClick={() => setCurrentPage(i + 1)}
                  className={`px-3 py-1 border rounded ${currentPage === i + 1 ? 'bg-blue-600 text-white' : ''
                    }`}
                >
                  {i + 1}
                </button>
              ))}
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}


        </>
      ) : creating ? (
        <CreateSubTemplate onBack={handleBack} />
      ) : (
        <SubscriptionDetail subscription={selectedSubscription} onBack={handleBack} />
      )}
    </div>
  );
};

export default Subscription;
